/**
 * [BLURY] | 🥭 reference composition
 * The look the studio resets to. Kept as a factory so callers always get a
 * fresh, mutation-safe copy.
 * @build 13.09.26
 * @updated 13.09.26 PHT
 * @author TONYTONY Sàrl
 */
import type { Composition, Ratio, Shape } from '@/engine/types';

export const REFERENCE_RATIO: Ratio = { w: 3, h: 4 };

/** Output width the studio starts and resets to — 900 × 1200 at 3:4. */
export const REFERENCE_WIDTH = 900;

export const DEFAULT_EXPORT_QUALITY = 0.9;

const REFERENCE_SHAPES: Shape[] = [
  { x: 0.17, y: 0.02, r: 0.294, c: '#dcd4b6', a: 0.86 },
  { x: 0.4, y: 0.0, r: 0.208, c: '#d2cfb4', a: 0.66 },
  { x: 1.0, y: 0.25, r: 0.225, c: '#cdd3c2', a: 0.8 },
  { x: 0.86, y: 0.1, r: 0.346, c: '#17bed0', a: 0.7 },
  { x: 0.03, y: 0.16, r: 0.208, c: '#5cc6dc', a: 0.6 },
  { x: 0.55, y: 0.615, r: 0.346, c: '#15c0d4', a: 0.55 },
  { x: 0.28, y: 0.42, r: 0.26, c: '#0481b6', a: 0.42 },
];

export const NEW_SHAPE_COLOR = '#bfc9b6';

export function referenceComposition(): Composition {
  return {
    deep: '#058cbe',
    cyan: '#15b7ca',
    pale: '#cfe2e0',
    horizon: 73,
    hsoft: 24,
    scale: 100,
    opacity: 100,
    blur: 96,
    sat: 104,
    con: 100,
    grain: 52,
    gsize: 1,
    gdens: 100,
    gblend: 'overlay',
    gtype: 'mono',
    shapes: REFERENCE_SHAPES.map(s => ({ ...s })),
  };
}
